import { invalidateCache as invalidateQueryOriginStatusCache } from '@monorepo/shared/hooks/useQueryOriginStatus';
import { invalidateCache as invalidateQueryResultsCache } from '@monorepo/shared/hooks/useQueryResults';
import { invalidateCache as invalidateViewQueryResultsCache } from '@monorepo/logs/src/hooks/useViewQueryResults';
import {
  getCache as getViewsCache,
  setCache as setViewsCache,
} from '@monorepo/logs/src/hooks/useViews';
import {
  PushMessageTopic as PMT,
  QueryOriginChangeType,
  ServerToClientMessages,
} from 'mapistry-shared';
import { useThrottledOnArgsMessageHandler } from '../webSocket';

const onQueryOriginChanged: ServerToClientMessages[PMT.QueryOriginChanged] = ({
  organizationId,
  queryOriginId,
  viewsUsingThisOrigin,
  changeType,
}) => {
  void invalidateQueryOriginStatusCache({
    organizationId,
    originId: queryOriginId,
  });

  // surgical update of the views cache for the projects affected by the change
  const projectsAffected = new Set<string>(
    viewsUsingThisOrigin.map(({ projectId }) => projectId),
  );
  projectsAffected.forEach((projectId) => {
    const viewsCache = getViewsCache({ organizationId, projectId });
    if (viewsCache) {
      const updatedViews = viewsCache.map((view) => {
        if (view.originId === queryOriginId) {
          return {
            ...view,
            originStatus: {
              isStale: changeType === QueryOriginChangeType.INVALIDATED,
            },
          };
        }
        return view;
      });
      setViewsCache({ organizationId, projectId }, updatedViews);
    }
  });

  // no need to invalidate the query results if the origin was just invalidated
  if (changeType === QueryOriginChangeType.INVALIDATED) return;

  void invalidateQueryResultsCache({
    organizationId,
    originId: queryOriginId,
  });
  viewsUsingThisOrigin.forEach(({ viewId, projectId }) => {
    void invalidateViewQueryResultsCache({
      organizationId,
      projectId,
      viewId,
    });
  });
};

export function useQueryOriginPushMessageHandlers() {
  useThrottledOnArgsMessageHandler(
    PMT.QueryOriginChanged,
    onQueryOriginChanged,
  );
}
